import React, { useState } from 'react';
import { sectionLabel, box } from './styles';

// A collapsed-by-default section of the cart builder's left pane. The body
// mounts only when opened, so a section that reads the account's products
// asks for them only when the rep wants it.
export default function Section({ title, children }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', background: 'none', border: 'none', padding: 0, marginBottom: open ? 6 : 10, cursor: 'pointer' }}
      >
        <span style={{ ...sectionLabel, margin: 0 }}>{title}</span>
        <span style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'var(--mono)', lineHeight: 1 }}>{open ? '−' : '+'}</span>
      </button>
      {open && <div style={box}>{children}</div>}
    </>
  );
}
